import { Config } from "../../types";
import Unsplash from "./Unsplash";
import UnsplashSettings from "./UnsplashSettings";

const config: Config = {
  key: "background/unsplash",
  name: "Nature Wallpaper",
  description: "Curated natural imagery from multiple sources.",
  dashboardComponent: Unsplash,
  settingsComponent: UnsplashSettings,
  supportsBackdrop: true,
};

export default config;
